import React from "react";
import ReactDOM from "react-dom";


import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
// import Main from './DemoPages/Main';
import { Provider } from "react-redux";
import App from "./App";
import { applyMiddleware, createStore } from "redux";
import rootReducer from "./reducers/rootReducer";
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { PersistGate } from 'redux-persist/integration/react';
import Storage from './services/Storage';
import { resetStateAction } from './reducers/ResetReducer';

// export const store = configureStore();


const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  // rootReducer,
  persistedReducer,
  // other store enhancers (like middleware) here
  composeWithDevTools(applyMiddleware(thunk))
);

const persistor = persistStore(store);

/**
 * Keep persisted Redux / localStorage aligned with real auth:
 * - No token → purge client session.
 * - Token but no tab marker → user closed the tab (sessionStorage cleared) while cookies/localStorage
 *   still look logged in; purge so they must sign in again. Reload in the same tab keeps sessionStorage.
 */
const ensureAuthStorageMatchesSessionCookies = async () => {
  const hasToken = Storage.hasValidAuthToken();

  if (!hasToken) {
    Storage.clearStaleAuthClientData();
    store.dispatch(resetStateAction());
    await persistor.purge();
    return;
  }

  if (!Storage.hasActiveTabLoginMarker()) {
    Storage.clearStaleAuthClientData();
    store.dispatch(resetStateAction());
    await persistor.purge();
    return;
  }
};

const rootElement = document.getElementById("root");

const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={ensureAuthStorageMatchesSessionCookies}
      >
        <HashRouter>
          <Component />
        </HashRouter>
      </PersistGate>
    </Provider>,
    rootElement
  );
};

renderApp(App);

// if (module.hot) {
//     module.hot.accept('./DemoPages/Main', () => {
//         const NextApp = require('./DemoPages/Main').default;
//         renderApp(NextApp);
//     });
// }
// serviceWorker.unregister();
